export enum CancellationReason {
    NO_LONGER_NEED_GUIDANCE = 'NO_LONGER_NEED_GUIDANCE',
    NO_TIME = 'NO_TIME',
    TOO_EXPENSIVE = 'TOO_EXPENSIVE',
    LIFE_CHANGE = 'LIFE_CHANGE',
    DOES_NOT_WANT_TO_ADOPT = 'DOES_NOT_WANT_TO_ADOPT',
    DOES_NOT_MEET_EXPECTATIONS = 'DOES_NOT_MEET_EXPECTATIONS',
    PRODUCT_ONBOARDING_OR_ACCOUNT_LINKING = 'PRODUCT_ONBOARDING_OR_ACCOUNT_LINKING',
    PRODUCT_MONEY_SYSTEM = 'PRODUCT_MONEY_SYSTEM',
    PRODUCT_BANKING_ISSUES = 'PRODUCT_BANKING_ISSUES',
    PRODUCT_INVESTMENT_MANGEMENT = 'PRODUCT_INVESTMENT_MANGEMENT',
    PRODUCT_NO_ANDROID_APP = 'PRODUCT_NO_ANDROID_APP',
    PRODUCT_OTHER_MISSING_FEATURE = 'PRODUCT_OTHER_MISSING_FEATURE',
    GUIDANCE_SWITCHED_ADVISORS = 'GUIDANCE_SWITCHED_ADVISORS',
    GUIDANCE_NO_EVENING_SESSIONS = 'GUIDANCE_NO_EVENING_SESSIONS',
    GUIDANCE_SCHEDULING_ISSUES = 'GUIDANCE_SCHEDULING_ISSUES',
    FINANCIAL_HIGH_DTI = 'FINANCIAL_HIGH_DTI',
    FINANCIAL_NEGATIVE_CASH_FLOW = 'FINANCIAL_NEGATIVE_CASH_FLOW',
    COMPLIANCE_NOT_US_BASED = 'COMPLIANCE_NOT_US_BASED',
    COMPLIANCE_CONFLICTING_INTERESTS = 'COMPLIANCE_CONFLICTING_INTERESTS',
    COMPLIANCE_EMIGRANT_INITIATED = 'COMPLIANCE_EMIGRANT_INITIATED',
    FRAUD_SUSPECTED = 'FRAUD_SUSPECTED',
    FRAUD_CONFIRMED = 'FRAUD_CONFIRMED',
    FRAUD_BOT = 'FRAUD_BOT',
    HOSPITALITY_DISENGAGED = 'HOSPITALITY_DISENGAGED',
    HOSPITALITY_MEMBERSHIP_PAST_DUE = 'HOSPITALITY_MEMBERSHIP_PAST_DUE',
    HOSPITALITY_NOT_HOSPITABLE = 'HOSPITALITY_NOT_HOSPITABLE',
    HOSPITALITY_NOT_COMFORTABLE_WITH_TECH = 'HOSPITALITY_NOT_COMFORTABLE_WITH_TECH',
    OTHER = 'OTHER',
    NONE = 'NONE',
}
